import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { X, ArrowRight } from 'lucide-react';
import { track } from '../lib/analytics';

/**
 * Small golden popup pinned to the bottom-right corner.
 * Dismissible (remembered for the session). Hidden for authenticated users.
 */
export default function FloatingCTA() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    // Don't show to authed users (best-effort: check the same cookie indicator the
    // app already uses — if not set, treat as anonymous).
    const dismissed = sessionStorage.getItem('floating_cta_dismissed') === '1';
    if (dismissed) return;
    // Slight delay so it doesn't appear instantly with the page
    const t = setTimeout(() => setOpen(true), 800);
    return () => clearTimeout(t);
  }, []);

  if (!open) return null;

  const dismiss = () => {
    sessionStorage.setItem('floating_cta_dismissed', '1');
    setOpen(false);
  };

  return (
    <div
      data-testid="floating-cta"
      className="fixed bottom-24 sm:bottom-28 right-5 sm:right-6 z-40 max-w-[320px] fade-in-up"
      role="dialog"
      aria-label="Sign up prompt"
    >
      <div className="relative bg-gradient-to-br from-[#E8C874] via-[#C9A24B] to-[#9C7C2F] text-[#1a1407] rounded-lg shadow-[0_18px_44px_-16px_rgba(201,162,75,0.55)] border border-[#E8C874]/40 p-4 pr-9 cta-sheen">
        <button
          type="button"
          onClick={dismiss}
          aria-label="Dismiss"
          data-testid="floating-cta-dismiss"
          className="absolute top-2 right-2 w-6 h-6 inline-flex items-center justify-center rounded-full hover:bg-black/10 transition-colors"
        >
          <X size={14} strokeWidth={2.4} />
        </button>
        <p className="font-display font-semibold text-sm leading-snug">
          Hey, it&apos;s Talas — ready to start your free account?
        </p>
        <Link
          to="/signup"
          data-testid="floating-cta-link"
          onClick={() => {
            track('sign_up_click', { source: 'floating_cta' });
            sessionStorage.setItem('floating_cta_dismissed', '1');
          }}
          className="mt-2 inline-flex items-center gap-1 font-mono text-xs font-semibold uppercase tracking-wider underline underline-offset-2 decoration-[#1a1407]/40 hover:decoration-[#1a1407]"
        >
          Sign up free
          <ArrowRight size={12} strokeWidth={2.4} />
        </Link>
      </div>
    </div>
  );
}
